import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DashWelcome from '../components/DashWelcome';
import { Button } from '../components/Button';
import TabNavigation from '../components/TabNavigation';
import useSectionLayout from '../hooks/useSectionLayout';
import { ProtectedLayout } from '../components/ProtectedLayout';


// Section components
import GoldFileSection from '../components/GoldFileSection';
import VisionSection from '../components/VisionSection';
import GrowthOpportunitiesSection from '../components/GrowthOpportunitiesSection';
import GoalsSection from '../components/GoalsSection';
import CommunitySection from '../components/CommunitySection';
import GrowthInstructions from '../components/GrowthInstructions';
import LessonsSection from '../components/LessonsSection';

export function DashTools() {
  const navigate = useNavigate();
  const { locations } = useSectionLayout();

  const [openSections, setOpenSections] = useState({
    gold_file: false,
    growth_opportunities: false,
    goals: false,
    community: false,
    vision: false,
    lessons: false
  });

  const toggleSection = (key: string) => {
    setOpenSections(prev => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <ProtectedLayout>
      <div className="p-4 max-w-4xl mx-auto space-y-6 relative">
        <DashWelcome />

        {/* Vision Section - Added above other sections */}
        {locations?.vision === 'tools' && (
          <VisionSection
            open={openSections.vision}
            toggle={toggleSection}
            sectionKey="vision"
          />
        )}

        {locations?.growth_instructions === 'tools' && <GrowthInstructions />}

        {locations?.gold_file === 'tools' && (
          <GoldFileSection
            open={openSections.gold_file}
            toggle={toggleSection}
          />
        )}

       {/*
  {locations?.growth_opportunities === 'tools' && (
    <GrowthOpportunitiesSection
      open={openSections.growth_opportunities}
      toggle={toggleSection}
      sectionKey="growth_opportunities"
      progress={{}}
      toggleItem={() => {}}
    />
  )}
*/}

        {locations?.goals === 'tools' && (
          <GoalsSection
            open={openSections.goals}
            toggle={toggleSection}
            sectionKey="goals"
          />
        )}

        {locations?.community === 'tools' && (
          <CommunitySection
            open={openSections.community}
            toggle={toggleSection}
            sectionKey="community"
          />
        )}

        {locations?.lessons === 'tools' && (
          <LessonsSection
            open={openSections.lessons}
            toggle={toggleSection}
            sectionKey="lessons"
            showChevron={false}
          />
        )}

        <TabNavigation />
      </div>
    </ProtectedLayout>
  );
}